import React from 'react';

import { Folder } from '@qality/common-model';
import { FolderWithParent } from '@qality/common-model/src/Folder';

import { ContainerStyled, ParentNameStyled } from './FolderPath.styled';

type InnerRef = ((instance: any) => void) | React.RefObject<HTMLSpanElement>;

type Props = {
  folder: Folder | FolderWithParent;
  showOnlyFolderName?: boolean;
  innerRef?: InnerRef;
};

const generatePath = (parentFolder: Folder): string => {
  if (!parentFolder) return '';

  const grandParentPath = parentFolder.parentId ? '... / ' : '';
  const parentPath = parentFolder.name ? parentFolder.name + ' / ' : '';

  return grandParentPath + parentPath;
};

export function FolderPath({
  folder,
  showOnlyFolderName = false,
  innerRef,
}: Props): JSX.Element {
  const folderPath =
    folder.parentId !== null ? generatePath(folder.parent) : '';

  return (
    <ContainerStyled innerRef={innerRef}>
      {!showOnlyFolderName && <ParentNameStyled>{folderPath}</ParentNameStyled>}
      {folder.name}
    </ContainerStyled>
  );
}
